export interface ActiveClinicContext {
  clinicId: string;
  clinicName?: string;
}

export interface AuthSessionHandlers {
  refreshAccessToken: () => Promise<void>;
  logout: () => void;
  getActiveClinic: () => ActiveClinicContext | null | undefined;
}

let handlers: AuthSessionHandlers | null = null;

export function registerAuthSessionHandlers(next: AuthSessionHandlers): void {
  handlers = next;
}

export function getAuthSessionHandlers(): AuthSessionHandlers {
  if (!handlers) {
    throw new Error(
      'Auth session handlers are not registered. ' +
        'Call registerAuthSessionHandlers from auth-store during bootstrap.',
    );
  }
  return handlers;
}

/** Clears tenant-scoped client state on logout / clinic switch. */
let sessionCleanup: (() => void) | null = null;

export function registerSessionCleanup(fn: () => void): void {
  sessionCleanup = fn;
}

export function runSessionCleanup(): void {
  sessionCleanup?.();
}
